/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Use_Embedded_Activities_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to use Activities." |
*
* @param {Leveling_Perm_Use_Embedded_Activities_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_use_embedded_activities_hint = /** @type {((inputs?: Leveling_Perm_Use_Embedded_Activities_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Use_Embedded_Activities_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам использовать активности.")
	return /** @type {LocalizedString} */ ("Allows members to use Activities.")
});